import { AppBar, MenuItemLink, UserMenu, useTranslate } from 'react-admin';
import { Box, Typography } from '@material-ui/core';
import { ToggleThemeButton } from "@react-admin/ra-preferences";
import { LanguageSwitcher } from "@react-admin/ra-preferences";
import { forwardRef } from 'react';
import SettingsIcon from '@material-ui/icons/Settings';
import MenuBook from '@material-ui/icons/MenuBook';
import { Tooltip, IconButton } from '@material-ui/core';
const ConfigurationMenu = forwardRef<any, any>((props, ref) => {
    const translate = useTranslate();
    return (
        <MenuItemLink {...props}
            ref={ref}
            to="/settings"
            primaryText={translate('resources.settings')}
            leftIcon={<SettingsIcon />}
            onClick={props.onClick}
            sidebarIsOpen
        />
    );
});

const CustomUserMenu = (props: any) => (
    <UserMenu {...props}>
        <ConfigurationMenu />
    </UserMenu>
);

const DocumentationButton = () => {
    const translate = useTranslate();
    const openDoc = () => {
        window.open("https://geofitgroupmail.sharepoint.com/:b:/s/OUTILGPAO/ESy5CVT20yxImr2WwtMlrdMB-9K04Nt5SIKNNATmMRbinA?e=Ohy9bQ")
    };
    return <Tooltip title={translate("resources.documentation")}>
        <IconButton
            color="inherit"
            aria-label={translate("resources.documentation")}
            onClick={openDoc}
        >
            <MenuBook />
        </IconButton>
    </Tooltip>;
};

const Bar = (props) => (
    <AppBar {...props} userMenu={<CustomUserMenu />}>
        <Box flex="1">
            <Typography variant="h6" id="react-admin-title"></Typography>
        </Box>
        <ToggleThemeButton />
        <LanguageSwitcher languages={[
            { locale: "en", name: "English" },
            { locale: "fr", name: "Français" },
        ]} />
        <DocumentationButton />
    </AppBar>
);

export default Bar;